
import SigninViewDefault from '~/components/account/SigninViewDefault.vue';
export default {
  name: 'AccountSigninPage',
  components: {
    SigninViewDefault
  },
  data() {
    return {
      config: {
        provider: 'punchh',
        placement: 'account',
        redirect_page_on_success: '/',
        forgot_placement: 'below',
        forgot_text: 'Forgot Password?',
        signin_text: 'Sign In',
        submit_icon: false,
        component_animation: '',
        background_animation: '',
        form_animation: 'animate__animated animate__fadeInRight',
        create_account_placement: 'below',
        signin_header: {
          title: 'Sign In',
          navLinks: [
            { 
              route: '/account/signup', 
              name: 'Create a New Account'
            }
          ],
          helper: 'ARE YOU NEW HERE?',
        },
        verify_header: {
          title: 'Verify With Passcode',
          navLinks: [],
          icon: {},
        },
        code_header: {
          title: 'Enter Your Code',
          navLinks: [],
          icon: {},
        },
        account_alert: {
          show: false,
          icon_name: 'info-icon',
          icon_classes: '',
          title: 'Have an account already?',
          copy: 'Use the same email as before to create a new account and we’ll reload your Reward Points!',
          enter_animation: 'animate__animated animate__slideInRight',
          leave_animation: 'animate__animated animate__slideOutRight',
          leave_timeout: 0,
          leave_timeout: 7000,
        },
      }
    }
  },
  head() {
    return this.$utils.head(this.story)
  },
  async asyncData({ $utils }) {
    const signin = await $utils.content('account/signin')
    if (!signin) {
      return {
        story: null,
        signinStoryblok: undefined,
      }
    }

    const sections = signin.content.sections || []
    const sectionFound = sections.find(section => section.component === 'sign-in-up-forgot-confirmed')
    const signinStoryblok = sectionFound ? sectionFound : null

    return {
      story: signin,
      signinStoryblok,
    }
  },
}
